import React from 'react'
// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'
// icons
import SettingsIconOrigin from '@mui/icons-material/Settings'
// utils
import { size } from 'polished'

export const SettingsIcon = styled(SettingsIconOrigin)`
  && {
    margin: 0 !important;
    ${size('18px')};

    path {
      fill: ${colors.blue500};
    }
  }
`
